module.exports = __webpack_public_path__ + "static/media/ArrowRight.82ccd36f.svg";